import { Card, CardBody, Col, Container, Input, Label, Row } from 'reactstrap'
import DataTable, { TableColumn } from "react-data-table-component";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  FormGroup,
} from "reactstrap";
// import CollapseFilterData from './CollapseFilterData';
import { useEffect, useMemo, useState } from 'react';
import { SearchTableButton } from '../../../../utils/Constant';
import { OfferListTableOfferComponent, OfferListTableStatus } from '../../../../Data/Application/Ecommerce/AllTicketOfferList';
import api from '../../../../utils/api';
import Swal from 'sweetalert2';
import { TicketOfferListTableDataColumnType } from '../../../../Types/Application/Ecommerce/Ecommerce';
import { SVG } from '../../../../AbstractElements';
import TicketOfferListFilterHeader from './TicketOfferListFilterHeader';

const TicketOfferListContainer = () => {
  const [filterText, setFilterText] = useState("");
  const [offerListTableDatas, setOfferListTableDatas] = useState<TicketOfferListTableDataColumnType[]>([]);

const [currentPage, setCurrentPage] = useState(1);
const [pageSize, setPageSize] = useState(10);
const [totalRows, setTotalRows] = useState(0);
const [loading, setLoading] = useState(false);

   const [editModalOpen, setEditModalOpen] = useState(false);
    const [editData, setEditData] = useState<any>(null);

    // useEffect(() => {
    //   const fetchOffers = async () => {
    //     try {
    //       const response = await api.get('/api/OfferPlan/GetOfferPlan'); 
    //       if (response.status === 200) {
    //         setOfferListTableDatas(response.data.map((item: {offerPlanId:any, offerName: any; offerType: any; offerValue: any; isOfferActive: any; originalPrice: any }) => ({
    //           offerPlanId: item.offerPlanId,
    //           offer_title: item.offerName,
    //           offer_type: item.offerType === 1 ? "Percentage" : "Amount",
    //           offer_discount: item.offerValue,
    //           offer_status: item.isOfferActive ? "Active" : "Inactive",
    //           originalPrice: item.originalPrice
    //         })));
    //       }
    //     } catch (error) {
    //       console.error("Failed to fetch offer list:", error);
    //     }
    //   };
  
    //   fetchOffers();
    // }, []);


    const fetchOffers = async () => {
      try {
        setLoading(true);
        const response = await api.get(
          `/api/OfferPlan/GetAllTicketOfferPlan`
        );
            if (response.status === 200) {
            setOfferListTableDatas(response.data.map((item: {ticketOfferId:any; offerName: any; freeType: any; adultBuy: any; childBuy: any; totalFree: any; totalCount: any; isOfferActive: any; }) => ({
              ticketOfferId: item.ticketOfferId,
              offerName: item.offerName,
              freeType: item.freeType,
              adultBuy: item.adultBuy,
              isOfferActive: item.isOfferActive ? "Active" : "Inactive",
              childBuy: item.childBuy,
              totalFree: item.totalFree,
              totalCount: item.totalCount,
            })));
          setTotalRows(response.data.length); // ⬅️ IMPORTANT
        }
      } catch (error) {
        console.error("Failed to fetch ticket list:", error);
      } finally {
        setLoading(false);
      }
    };
    
    
      useEffect(() => {
      fetchOffers();
    }, []);

    const handleDelete = async (id: number) => {
      Swal.fire({
          title: 'Are you sure?',
          text: 'You will not be able to recover this offer!',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#d33',
          cancelButtonColor: '#3085d6',
          confirmButtonText: 'Yes, delete it!',
      }).then((result) => {
          if (result.isConfirmed) {
              confirmDelete(id);
          }
      });
    };

    const confirmDelete = async (id: number) => {
      try {
        await api.delete(`/api/OfferPlan/DeleteTicketOfferPlan)?OfferId=${id}`);
        Swal.fire('Deleted!', 'Offer has been deleted.', 'success');
    
        // Optional: refresh the list
        setOfferListTableDatas((prev) => prev.filter((item: { ticketOfferId: any; }) => item.ticketOfferId !== id));
      } catch (error) {
        Swal.fire('Error!', 'Failed to delete the offer.', 'error');
        console.error("Delete error:", error);
      }
    }

    // Edit

     const handleEdit = (row: any) => {
        setEditData(row);
        setEditModalOpen(true);
      };
    
      const handleEditChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setEditData({ ...editData, [e.target.name]: e.target.value });
      };
    
      const handleEditSave = async () => {
        // if (!editData || !editData.offerPlanId || !editData.offer_title || !editData.offerType || !editData.offer_discount || !editData.originalPrice) {
        //   Swal.fire("Error!", "Please fill all fields before saving.", "error");
        //   return;
        // }
        if (editData.offerName.trim() === "") {
          Swal.fire("Error!", "Offer name cannot be empty.", "error");
          return;
        }
        if (isNaN(Number(editData.totalCount)) || Number(editData.totalCount) < 0) {
          Swal.fire("Error!", "Please enter a valid total number of ticket.", "error");
          return;
        }
        if (isNaN(Number(editData.totalFree)) || Number(editData.totalFree) <= 0) {
          Swal.fire("Error!", "Please enter a valid number of free ticket.", "error");
          return;
        }
        if (isNaN(Number(editData.adultBuy)) || Number(editData.adultBuy) < 0) {
          Swal.fire("Error!", "Please enter a valid number of adult ticket.", "error");
          return;
        }
        if (isNaN(Number(editData.childBuy)) || Number(editData.childBuy) < 0) {
          Swal.fire("Error!", "Please enter a valid number of child ticket.", "error");
          return;
        }
        try {
          await api.put(`/api/OfferPlan/UpdateTicketOfferPlan`, {
            offerId: editData.ticketOfferId,
            offerName: editData.offerName, 
            freeType: editData.freeType,
            adultBuy: editData.adultBuy, 
            isOfferActive: editData.isOfferActive === "Active" ? true : false,
            childBuy: editData.childBuy,
            totalCount:editData.totalCount,
            totalFree: editData.totalFree
          });
          // setOfferListTableDatas((prev) =>
          //   prev.map((item: any) =>
          //     item.offerPlanId === editData.offerPlanId ? editData : item
          //   )
          // );
          await fetchOffers();
          setEditModalOpen(false);
          Swal.fire("Updated!", "The offer has been updated.", "success");
        } catch (error) {
          Swal.fire("Error!", "Failed to update the offer.", "error");
        }
      };
    

    const offerListTableDataColumn: TableColumn<TicketOfferListTableDataColumnType>[] = [
      {
        name: "Offer Name",
        cell: (row) => <OfferListTableOfferComponent title={row.offerName}/>,
        sortable: true,
        grow: 2,
        width: '150px',
      },
      {
        name: "Offer For",
        selector: (row) => `${row.freeType}`,
        sortable: true,
        grow: 2,
      },
      {
        name: "Adults",
        selector: (row) => `${row.adultBuy}`,
        sortable: true,
      },
      {
        name: "Childs",
        selector: (row) => `${row.childBuy}`,
        sortable: true,
      },
      {
        name: "Total Free",
        selector: (row) => `${row.totalFree}`,
        sortable: true,
        width: '150px',
      },
      {
        name: "Total Tickets",
        selector: (row) => `${row.totalCount}`,
        sortable: true,
        width: '150px',
      },
      {
        name: "Offer Status",
        cell: (row) =>  <OfferListTableStatus title={row.isOfferActive} />,
        width: '150px',
      },
      // {
      //   name: "Action",
      //   cell: (row) => <OfferListTableAction offerPlanId={row.offerPlanId} onDelete={handleDelete} />,
      // },

      {
              name: "Action",
              cell: (row) => (
                <div className="d-flex align-items-center gap-2">
                  <span
                    onClick={() => handleEdit(row)}
                    title="Edit"
                    style={{ cursor: "pointer" }}
                  >
                    <SVG
                      iconId="edit-content"
                      style={{ fill: "blue", width: 18, height: 18 }}
                    />
                  </span>
                  <span
                    onClick={() => handleDelete(Number(row.ticketOfferId))}
                    title="Delete"
                    style={{ cursor: "pointer" }}
                  >
                    <SVG
                      iconId="trash1"
                      style={{ fill: "red", width: 18, height: 18 }}
                    />
                  </span>
                </div>
              ),
            },
    ];

  const filteredItems = offerListTableDatas.filter((item: any) => {
    if (!filterText) return true;
    const search = filterText.toLowerCase();
    return Object.values(item).some((value) =>
        value?.toString().toLowerCase().includes(search)
    );
  });

  const subHeaderComponentMemo = useMemo(() => {
    return (
      <div className="dataTables_filter d-flex align-items-center">
        <Label className="me-2">{SearchTableButton}:</Label>
        <Input onChange={(e: React.ChangeEvent<HTMLInputElement>) => setFilterText(e.target.value)} type="search" value={filterText} />
      </div>
    );
  }, [filterText]);


const handlePageChange = (page: number) => {
  setCurrentPage(page);
};

const handlePerRowsChange = (newPerPage: number, page: number) => {
  setPageSize(newPerPage);
  setCurrentPage(page);
};


  return (
    <Container fluid>
      <Row>
        <Col sm="12">
          <Card>
            <CardBody>
              <div className="list-product-header">
                <TicketOfferListFilterHeader />
                {/* <CollapseFilterData /> */}
              </div>
              <div className="list-product">
                <div className="table-responsive">
                  {/* <DataTable data={filteredItems} columns={offerListTableDataColumn} striped highlightOnHover pagination selectableRows subHeader subHeaderComponent={subHeaderComponentMemo} /> */}

                   <DataTable
                    data={filteredItems}
                    //  data={offerListTableDatas}
                    columns={offerListTableDataColumn}
                    striped
                    highlightOnHover
                    pagination
                    paginationServer // ⬅️ 
                    paginationTotalRows={totalRows} // ⬅️ 
                    onChangePage={handlePageChange} // ⬅️ 
                    onChangeRowsPerPage={handlePerRowsChange} // ⬅️ 
                    paginationDefaultPage={currentPage} // ⬅️
                    paginationPerPage={pageSize} // ⬅️ 
                    progressPending={loading} // ⬅️ 
                    selectableRows
                    subHeader
                    subHeaderComponent={subHeaderComponentMemo}
                  />
                </div>
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
        <Modal
              isOpen={editModalOpen}
              toggle={() => setEditModalOpen(!editModalOpen)}
            >
              <ModalHeader toggle={() => setEditModalOpen(!editModalOpen)}>
                Edit Offer
              </ModalHeader>
              <ModalBody>
                {editData && (
                  <>
                    <FormGroup>
                      <Label>Offer Name</Label>
                      <Input
                        name="offerName"
                        value={editData.offerName}
                        onChange={handleEditChange}
                      />
                    </FormGroup>
                    <FormGroup>
                      <Label>Offer For</Label>
                      <Input
                        type="select"
                        name="freeType"
                        value={editData.freeType}
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                          const value = e.target.value;
                          handleEditChange({
                            ...e,
                            target: {
                              ...e.target,
                              name: "freeType",
                              value,
                            },
                          });
                        }}
                      >
                        <option value="Adult">Adult</option>
                        <option value="Child">Child</option>
                      </Input>
                    </FormGroup>
                    <FormGroup>
                      <Label>No. Of Adults</Label>
                      <Input
                        name="adultBuy"
                        value={editData.adultBuy}
                        onChange={handleEditChange}
                      />
                    </FormGroup>
                    <FormGroup>
                      <Label>No. Of Child</Label>
                      <Input
                        name="childBuy"
                        value={editData.childBuy}
                        onChange={handleEditChange}
                      />
                    </FormGroup>
                    <FormGroup>
                      <Label>Free Ticket</Label>
                      <Input
                        name="totalFree"
                        value={editData.totalFree}
                        onChange={handleEditChange}
                      />
                    </FormGroup>
                    <FormGroup>
                      <Label>Total Ticket</Label>
                      <Input
                        name="totalCount"
                        value={editData.totalCount}
                        onChange={handleEditChange}
                      />
                    </FormGroup>
                    <FormGroup>
                      <Label>offer status</Label>
                        <Input
                        type="select"
                        name="isOfferActive"
                        value={editData.isOfferActive}
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                          setEditData({
                          ...editData,
                          isOfferActive: e.target.value,
                          });
                        }}
                        >
                        <option value="true">Active</option>
                        <option value="false">Inactive</option>
                        </Input>
                    </FormGroup>
                   
                  </>
                )}
              </ModalBody>
              <ModalFooter>
                <Button color="secondary" onClick={() => setEditModalOpen(false)}>
                  Cancel
                </Button>
                <Button color="primary" onClick={handleEditSave}>
                  Save
                </Button>
              </ModalFooter>
            </Modal>
    </Container>
  )
}

export default TicketOfferListContainer